import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../../helpers/common'
import { toast } from 'react-toastify';

export const UsersManagementLoadingKeys = {
    getUsers: "GET_USERS",
    getRoles: "GET_ROLES",
    getUserRolesBySelect: "GET_USER_ROLES_BY_SELECT",
    getRolesToReassign: "GET_ROLES_TO_REASSIGN",
    // deletePurchaseOrder: "DELETE_PURCHASE_ORDER",
    disableUser: "DISABLE_USER",
    enableUser: "ENABLE_USER",
    removeUser: "REMOVE_USER",
    removeRole: "REMOVE_ROLE",
    getAuditInfo: "GET_AUDIT_INFO",
    getUsersToSelect: "GET_USERS_TO_SELECT",
    makeDuplicateRole: "DUPLICATE_ROLE",
    updateUserInfo: "UPDATE_USER_INFO",
    updateRoleInfo: "UPDATE_ROLE_INFO",
    addUser: "ADD_USER"
    // getPurchaseOrderById: "GET_PURCHASE_ORDER_BY_ID",
    // updatePurchaseOrder: "UPDATE_PURCHASE_ORDER"
}

const initialState = {
  roles: [],
  users: [],
  userRoles: [],
  auditInfo: [],
  usersToSelect: [],
  isFirstLoadComplete: false,
  loadingKeys: [],
  pagination: {
    isTheLastPage: false,
    rangeRows: "",
    totalPages: 0
  },
  loading: false,
}

export const addNewUser = createAsyncThunk(
  'users/addNewUser',
  async ({
    fullName, 
    email, 
    password, 
    selectedRole,
    slackId,
    search,
    role,
    status
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/users/add`, { 
        fullName, 
        email, 
        password, 
        selectedRole,
        slackId
      });
      dispatch(getUsers({ search, role, status }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error })
      }
    }
  }
)

export const updateRoleInfo = createAsyncThunk(
  'users/updateRoleInfo',
  async ({
    roleId,
    roleName,
    description,
    department,
    companyWideGovernance,
    permissions,
    search
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`/api/v1/management/roles/update`, { 
        roleId,
        roleName,
        description,
        department,
        companyWideGovernance,
        permissions,
      });
      dispatch(getRoles({ search }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error })
      }
    }
  }
) 

export const updateUserInfo = createAsyncThunk(
  'users/updateUserInfo',
  async ({
    id,
    newRoleId,
    fullName,
    email,
    password,
    slackId,
    search,
    role,
    status
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`/api/v1/management/users/update`, { 
        id, 
        newRoleId,
        fullName,
        email,
        password,
        slackId,
      });
      dispatch(getUsers({ search, role, status }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const getUserRolesBySelect = createAsyncThunk(
  'users/getUserRolesBySelect',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/user-roles-by-select`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const getRolesToReassign = createAsyncThunk(
  'users/getRolesToReassign',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/roles-to-reassign`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const getUsersToSelect = createAsyncThunk(
  'users/getUsersToSelect',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/users-to-select`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const getAuditInfo = createAsyncThunk(
  'users/getAuditInfo',
  async ({
    search,
    user,
    action
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/audit-users`, { params: { 
        search,
        user,
        action
      }});
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)


export const getRoles = createAsyncThunk(
  'users/getRoles',
  async ({
    search,
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/roles`, { params: { 
        search,
      }});
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const getUsers = createAsyncThunk(
  'users/getUsers',
  async ({
    search,
    role,
    status
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/management/users`, { params: { 
        search,
        role,
        status
      }});
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue({ error: error.response.data })
      } else {
        return rejectWithValue({ error: error.response.data.errors })
      }
    }
  }
)

export const makeDuplicateRole = createAsyncThunk(
  'users/makeDuplicateRole',
  async ({
    id,
    search,
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/roles/duplicate`, { id });
      dispatch(getRoles({ search }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const removeRole = createAsyncThunk(
  'users/removeRole',
  async ({
    id,
    newRole,
    search,
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/roles/remove`, { id, newRole });
      dispatch(getRoles({ search }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const removeUser = createAsyncThunk(
  'users/removeUser',
  async ({
    id,
    search,
    role,
    status
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/users/remove`, { id });
      dispatch(getUsers({ search, role, status }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const enableUser = createAsyncThunk(
  'users/enableUser',
  async ({
    id,
    search,
    role,
    status
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/users/enable`, { id });
      dispatch(getUsers({ search, role, status }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const disableUser = createAsyncThunk(
  'users/disableUser',
  async ({
    id,
    reason,
    search,
    role,
    status
  }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`/api/v1/management/users/disable`, { id, reason });
      dispatch(getUsers({ search, role, status }));
      return data;
    } catch (error) {
      if ('string' === typeof error?.response?.data) {
        return rejectWithValue({ error: error?.response?.data, id })
      } else {
        return rejectWithValue({ error: error?.response?.data?.errors || error?.response?.data?.error, id })
      }
    }
  }
)

export const usersManagementSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserRolesBySelect.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getUserRolesBySelect];
      })
      .addCase(getUserRolesBySelect.fulfilled, (state, action) => {
        state.loading = false;
        state.userRoles = action.payload?.items;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUserRolesBySelect, state.loadingKeys);
      })
      .addCase(getUserRolesBySelect.rejected, (state) => {
        state.loading = false;
        state.userRoles = [];
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUserRolesBySelect, state.loadingKeys);
      })
      .addCase(getRolesToReassign.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getRolesToReassign];
      })
      .addCase(getRolesToReassign.fulfilled, (state, action) => {
        state.loading = false;
        state.rolesToReassign = action.payload?.items;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getRolesToReassign, state.loadingKeys);
      })
      .addCase(getRolesToReassign.rejected, (state) => {
        state.loading = false;
        state.rolesToReassign = [];
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getRolesToReassign, state.loadingKeys);
      })
      .addCase(getUsersToSelect.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getUsersToSelect];
      })
      .addCase(getUsersToSelect.fulfilled, (state, action) => {
        state.loading = false;
        state.usersToSelect = action.payload?.items;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUsersToSelect, state.loadingKeys);
      })
      .addCase(getUsersToSelect.rejected, (state) => {
        state.loading = false;
        state.usersToSelect = [];
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUsersToSelect, state.loadingKeys);
      })
      .addCase(getAuditInfo.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getAuditInfo];
      })
      .addCase(getAuditInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.auditInfo = action.payload?.items;
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getAuditInfo, state.loadingKeys);
      })
      .addCase(getAuditInfo.rejected, (state) => {
        state.loading = false;
        state.auditInfo = [];
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getAuditInfo, state.loadingKeys);
      })
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getRoles];
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload?.items;
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getRoles, state.loadingKeys);
      })
      .addCase(getRoles.rejected, (state) => {
        state.loading = false;
        state.roles = [];
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getRoles, state.loadingKeys);
      })
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.getUsers];
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload?.items;
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUsers, state.loadingKeys);
      })
      .addCase(getUsers.rejected, (state) => {
        state.loading = false;
        state.users = [];
        state.isFirstLoadComplete = true;
        state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.getUsers, state.loadingKeys);
      })
      .addCase(makeDuplicateRole.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.makeDuplicateRole];
      })
      .addCase(makeDuplicateRole.fulfilled, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.makeDuplicateRole, state.loadingKeys);
          if (!action?.payload?.error) {
            toast.success(`Role duplicated successfully.`, { position: "bottom-right" })
          }
      })
      .addCase(makeDuplicateRole.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.makeDuplicateRole, state.loadingKeys);
          toast.error(
            `Role can't be duplicated. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(removeRole.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.removeRole];
      })
      .addCase(removeRole.fulfilled, (state) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.removeRole, state.loadingKeys);
          toast.success(`Role removed successfully.`, { position: "bottom-right" })
      })
      .addCase(removeRole.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.removeRole, state.loadingKeys);
          toast.error(
            `Role can't be removed. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(removeUser.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.removeUser];
      })
      .addCase(removeUser.fulfilled, (state) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.removeUser, state.loadingKeys);
          toast.success(`User removed successfully.`, { position: "bottom-right" })
      })
      .addCase(removeUser.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.removeUser, state.loadingKeys);
          toast.error(
            `User can't be removed. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(enableUser.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.enableUser];
      })
      .addCase(enableUser.fulfilled, (state) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.enableUser, state.loadingKeys);
          toast.success(`User enabled successfully.`, { position: "bottom-right" })
      })
      .addCase(enableUser.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.enableUser, state.loadingKeys);
          toast.error(
            `User can't be enabled. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(addNewUser.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.addUser];
      })
      .addCase(addNewUser.fulfilled, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.addUser, state.loadingKeys);
          if (!action?.payload?.error) {
            toast.success(`User added successfully.`, { position: "bottom-right" })
          }
      })
      .addCase(addNewUser.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.addUser, state.loadingKeys);
          toast.error(
            `User can't be added. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(updateRoleInfo.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.updateRoleInfo];
      })
      .addCase(updateRoleInfo.fulfilled, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.updateRoleInfo, state.loadingKeys);
          if (!action?.payload?.error) {
            toast.success(`Role updated successfully.`, { position: "bottom-right" })
          }
      })
      .addCase(updateRoleInfo.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.updateRoleInfo, state.loadingKeys);
          toast.error(
            `Role can't be updated. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(updateUserInfo.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.updateUserInfo];
      })
      .addCase(updateUserInfo.fulfilled, (state) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.updateUserInfo, state.loadingKeys);
          toast.success(`User updated successfully.`, { position: "bottom-right" })
      })
      .addCase(updateUserInfo.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.updateUserInfo, state.loadingKeys);
          toast.error(
            `User can't be updated. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
      .addCase(disableUser.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, UsersManagementLoadingKeys.disableUser];
      })
      .addCase(disableUser.fulfilled, (state) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.disableUser, state.loadingKeys);
          toast.success(`User disabled successfully.`, { position: "bottom-right" })
      })
      .addCase(disableUser.rejected, (state, action) => {
          state.loading = false;
          state.loadingKeys = removeLoadingKey(UsersManagementLoadingKeys.disableUser, state.loadingKeys);
          toast.error(
            `User can't be disabled. Error - ${action.error?.message}.`, { position: "bottom-right" }
          )
      })
  }
})

export const {} = usersManagementSlice.actions;

export default usersManagementSlice.reducer
